// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filename_laRui {
    padding-right: 16px;
}

.downloadErrorButton_Mp1an {
    position: relative;
    top: 4px;
    left: 28px;
}

.resultsTable_Uf4aM {
    overflow: auto;
    height: calc(100% - 50px);
}

.resultsTableBodySuccess_IOQek {
    overflow: auto;
    height: calc(100% - 102px);
}

.resultsTableBodyError_RhA_E {
    overflow: auto;
    height: calc(100% - 102px)
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/imagine/forms/BulkCreateResults.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd;AACJ","sourcesContent":[".filename {\n    padding-right: 16px;\n}\n\n.downloadErrorButton {\n    position: relative;\n    top: 4px;\n    left: 28px;\n}\n\n.resultsTable {\n    overflow: auto;\n    height: calc(100% - 50px);\n}\n\n.resultsTableBodySuccess {\n    overflow: auto;\n    height: calc(100% - 102px);\n}\n\n.resultsTableBodyError {\n    overflow: auto;\n    height: calc(100% - 102px)\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filename": `filename_laRui`,
	"downloadErrorButton": `downloadErrorButton_Mp1an`,
	"resultsTable": `resultsTable_Uf4aM`,
	"resultsTableBodySuccess": `resultsTableBodySuccess_IOQek`,
	"resultsTableBodyError": `resultsTableBodyError_RhA_E`
};
export default ___CSS_LOADER_EXPORT___;
